import React from 'react';
import { Alert } from 'react-bootstrap';
import { Interweave } from 'interweave';
import { useAnnouncements, useDismissAnnouncement } from '../helpers/api';
import { useAuth } from '../modules/auth';

// WST-1090: admin-authored announcements, stacked top-center one below the version banner.
export const AnnouncementBanner: React.FC = () => {
  const { currentUser } = useAuth();
  const { data: announcements } = useAnnouncements(!!currentUser);
  const dismiss = useDismissAnnouncement();

  if (!announcements?.length) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 75,
        left: 16,
        right: 16,
        zIndex: 1049,
        maxWidth: 600,
        margin: '0 auto',
      }}
    >
      {announcements.map((a, i) => (
        <Alert
          key={a.id}
          variant={a.severity === 'info' ? 'success' : a.severity}
          className="mb-2 shadow-sm"
          role={a.severity === 'info' ? 'status' : 'alert'}
          dismissible
          onClose={() => dismiss.mutate({ id: a.id, forever: false })}
        >
          <div className="fw-bolder fs-5 mb-2">{a.title}</div>
          <div className="announcement-body mb-3">
            <Interweave content={a.body_html} />
          </div>
          <div className="d-flex flex-wrap justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-sm btn-outline btn-outline-primary text-nowrap"
              onClick={() => dismiss.mutate({ id: a.id, forever: true })}
            >
              Don't show again
            </button>
            {/* Default action: focused so Enter snoozes the top announcement. */}
            <button
              type="button"
              className="btn btn-sm btn-primary text-nowrap"
              autoFocus={i === 0}
              onClick={() => dismiss.mutate({ id: a.id, forever: false })}
            >
              Remind me later
            </button>
          </div>
        </Alert>
      ))}
    </div>
  );
};
